import React from 'react'
import { Box } from '@mui/material'
import { State } from 'src/types'
import { useLocale } from 'src/locales/useLocale'
import { NoEmbroidery } from 'src/features/simulationConfirm/Components/NoEmbroidery'
import { ItemCell } from 'src/Components/Domain/ItemCell'
import { muiGrey } from 'src/style/muiTheme'
import { cellColor } from './SimulationContents'
import { genEmbroideryCells } from 'src/logic/simulationSpecification/glove'
import ja from 'src/locales/ja'
import tw from 'src/locales/zh-TW'
import en from 'src/locales/en'
import ko from 'src/locales/ko'

/**
 * ログインセッションがリセットされる「ムカつく」現象の再現手順
 * 1. localhostで、小売店画面にログインし、グラブを検索し検索結果を表示
 * 2. 何回か or 一定時間(たぶん数分？)経過後に、このファイルをいじって保存する
 * 3. 小売店画面に戻ると、ログインセッションがリセットされている☠️←これ直したい
 *
 * */

type Props = {
  state: State
  previousIndex: number
  shouldTranslate: boolean
}

export const GloveEmbroideries: React.FC<Props> = ({ state, previousIndex, shouldTranslate }) => {
  const { t, language } = useLocale()
  const embroideries = state.embroideries || []

  if (embroideries.filter((e) => e.content.trim().length > 0).length === 0) {
    return <NoEmbroidery />
  }

  const tt = language === 'en' ? en : language === 'ko' ? ko : language === 'zh-TW' ? tw : ja
  const embroideryCells = embroideries.map((e) => genEmbroideryCells(e, tt, language))

  return (
    <>
      {embroideryCells.map((embroidery, index) => (
        <Box mb={2} key={embroidery[index].head}>
          <Box fontWeight="bold" fontSize="16px" color={muiGrey}>
            {t.EMBROIDERY_ITEMS}
            {index + 1}
          </Box>
          {embroidery.map((cell, i) => (
            <ItemCell key={cell.head} itemIndex={i + previousIndex + index * 6} cell={cell} color={cellColor(cell?.value)} />
          ))}
        </Box>
      ))}
    </>
  )
}
